import { SearchFilterBar } from '@/components/base/SearchFilterBar';

interface LogFiltersProps {
  search: string;
  onSearchChange: (v: string) => void;
  fieldId: string;
  onFieldChange: (v: string) => void;
  seasonId: string;
  onSeasonChange: (v: string) => void;
  dateFrom: string;
  onDateFromChange: (v: string) => void;
  dateTo: string;
  onDateToChange: (v: string) => void;
  showWarning: boolean;
  onShowWarningChange: (v: boolean) => void;
  showHTXNote: boolean;
  onShowHTXNoteChange: (v: boolean) => void;
  showDeleted: boolean;
  onShowDeletedChange: (v: boolean) => void;
  fields: { id: string; name: string }[];
  seasons: { id: string; name: string }[];
}

export function LogFilters({
  search, onSearchChange,
  fieldId, onFieldChange,
  seasonId, onSeasonChange,
  dateFrom, onDateFromChange,
  dateTo, onDateToChange,
  showWarning, onShowWarningChange,
  showHTXNote, onShowHTXNoteChange,
  showDeleted, onShowDeletedChange,
  fields, seasons,
}: LogFiltersProps) {
  const hasAnyFilter = fieldId || seasonId || dateFrom || dateTo || showWarning || showHTXNote || showDeleted;
  const clearAll = () => {
    onFieldChange('');
    onSeasonChange('');
    onDateFromChange('');
    onDateToChange('');
    onShowWarningChange(false);
    onShowHTXNoteChange(false);
    onShowDeletedChange(false);
  };
  const activeView = showWarning ? 'warning' : showHTXNote ? 'note' : showDeleted ? 'deleted' : '';
  const selectView = (value: string) => {
    onShowWarningChange(value === 'warning');
    onShowHTXNoteChange(value === 'note');
    onShowDeletedChange(value === 'deleted');
  };

  return (
    <SearchFilterBar value={search} onChange={onSearchChange} placeholder="Tìm kiếm nội dung nhật ký..." selected={activeView} onSelect={selectView} options={[
      { value: '', label: 'Tất cả nhật ký' },
      { value: 'warning', label: 'Có cảnh báo', dotClass: 'bg-amber-500' },
      { value: 'note', label: 'Có ghi chú HTX', dotClass: 'bg-sky-500' },
      { value: 'deleted', label: 'Đã xóa', dotClass: 'bg-rose-500' },
    ]}>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        <select value={fieldId} onChange={(e) => onFieldChange(e.target.value)}
          className="w-full px-3 py-2.5 rounded-xl border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-agrida-500">
          <option value="">Tất cả thửa đất</option>
          {fields.map((f) => (<option key={f.id} value={f.id}>{f.name}</option>))}
        </select>
        <select value={seasonId} onChange={(e) => onSeasonChange(e.target.value)}
          className="w-full px-3 py-2.5 rounded-xl border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-agrida-500">
          <option value="">Tất cả mùa vụ</option>
          {seasons.map((s) => (<option key={s.id} value={s.id}>{s.name}</option>))}
        </select>
        <input type="date" value={dateFrom} onChange={(e) => onDateFromChange(e.target.value)}
          className="w-full px-3 py-2.5 rounded-xl border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-agrida-500" />
        <input type="date" value={dateTo} onChange={(e) => onDateToChange(e.target.value)}
          className="w-full px-3 py-2.5 rounded-xl border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-agrida-500" />
      </div>

        {hasAnyFilter && (
          <button type="button" onClick={clearAll} className="h-11 rounded-xl border border-slate-200 text-sm font-medium text-slate-600">Xóa bộ lọc</button>
        )}
    </SearchFilterBar>
  );
}
